import type { TargetingValue } from '../../models';

/**
 * Wrap a list of publisher names/ids as `TargetingValue` objects so they can be
 * fed to dropdowns/filters that expect the canonical TargetingValue shape.
 *
 * The id, name, and displayName are all set to the same string. Order is
 * preserved.
 */
export function getPublisherTargetLineItem(publishers: string[]): TargetingValue[] {
  return publishers.map((publisher) => ({
    id: publisher,
    displayName: publisher,
    name: publisher,
  }));
}
